var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58.794,
    height: 93.412,
    viewBox: "0 0 15.556 24.715",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fontSize: 37.333,
    fontFamily: "Ok",
    "white-space": "pre",
    fill: "#666e6e"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeFontSpecification: "Ok"
    },
    d: "M12.008 22.956a5.265 1.72 0 0 1-5.266 1.72 5.265 1.72 0 0 1-5.265-1.72 5.265 1.72 0 0 1 5.265-1.72 5.265 1.72 0 0 1 5.266 1.72z",
    fillOpacity: 0.667,
    stroke: "#666e6e",
    strokeWidth: 0.078,
    strokeOpacity: 0.671
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeFontSpecification: "Ok"
    },
    d: "M7.853 22.866a1.031.353 0 0 1-1.031.353 1.031.353 0 0 1-1.032-.353 1.031.353 0 0 1 1.032-.353 1.031.353 0 0 1 1.031.353z",
    fillOpacity: 0.667,
    strokeWidth: 0.048
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.845 11.144l1.127-1.303L2.562.896 0 0zm.418 11.584l1.012.354.92-10.026 7.361-7.611-2.561-.897-6.624 7.646z",
    style: {
      InkscapeFontSpecification: "Okeanys"
    },
    fillOpacity: 1,
    stroke: "#353838",
    strokeWidth: 0,
    strokeOpacity: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.26429559b6fedca67f0501943e3513d9.svg";
export { ForwardRef as ReactComponent };